import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "../PopularDestination/PopularDestination.css";
import India from "../../../icons/TourismIcons/India.png";
import UAE from "../../../icons/TourismIcons/UAE.png";
import SouthAfrica from "../../../icons/TourismIcons/SouthAfrica.png";
import KenyaTanzania from "../../../icons/TourismIcons/Kenya&Tanzania.png";
import ZambiaZimbabwe from "../../../icons/TourismIcons/Zambia&Zimbabwe.png";
import MoroccoRwanda from "../../../icons/TourismIcons/Morocco&Rwanda.png";

const PopularDestinations = () => {
  const destinations = [
    {
      name: "India",
      image: India,
    },
    {
      name: "UAE",
      image: UAE, 
    },
    {
      name: "South Africa",
      image: SouthAfrica, 
    },
    {
      name: "Kenya & Tanzania",
      image: KenyaTanzania, 
    },
    {
      name: "Zambia & Zimbabwe",
      image: ZambiaZimbabwe, 
    },
    {
      name: "Morocco & Rwanda",
      image: MoroccoRwanda, 
    },
  ];

  return (
    <div>
      <h1 className="headings text-center">
        <span>Popular M.I.C.E. </span>Destinations We Serve
      </h1>
      <div className="container">
        <div className="row">
          {destinations.map((destination, index) => (
            <div key={destination.name} className="col-md-2">
              <LazyLoadImage
            effect="blur"
 
                src={destination.image} 
                alt={destination.name} 
                className="pdimg mb-1 me-2" 
              />
              <text className="text-center pd-text d-flex justify-content-center">{destination.name}</text>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PopularDestinations;